<template>
  <v-layout row wrap>

    <v-layout row wrap>

      <v-flex lg12 sm12 xs12 style="padding: 10px">
        <v-alert
            border="left"
            color="orange"
            elevation="0"
            prominent
            type="info"
        >
          Batas waktu pembayaran jam 17:00 WIB, pembayaran di atas jam 17:00 WIB pencairan tidak dapat dilakukan
        </v-alert>
      </v-flex>

    </v-layout>

    <v-layout row wrap>
      <v-flex lg2 sm6 xs12>
        <v-card class="ma-3" elevation="0" style="border: thin solid rgba(0,0,0,.12)">
          <v-list-item>
            <v-list-item-content>
              <div class="text-right mb-2">Total Limit</div>
              <v-list-item-title class="headline mb-1 text-right">{{formatAngka(cashBalance.totalLimit)}}
              </v-list-item-title>
              <div>
                <v-divider></v-divider>
              </div>
            </v-list-item-content>
          </v-list-item>
          <v-card-actions>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex lg2 sm6 xs12>
        <v-card class="ma-3" elevation="0" style="border: thin solid rgba(0,0,0,.12)">
          <v-list-item>
            <v-list-item-content>
              <div class="text-right mb-2">Limit Request</div>
              <v-list-item-title class="headline mb-1 text-right">{{formatAngka(cashBalance.requestLimit)}}
              </v-list-item-title>
              <div>
                <v-divider></v-divider>
              </div>
            </v-list-item-content>
          </v-list-item>
          <v-card-actions>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex lg2 sm6 xs12>
        <v-card class="ma-3" elevation="0" style="border: thin solid rgba(0,0,0,.12)">
          <v-list-item>
            <v-list-item-content>
              <div class="text-right mb-2">Sisa Limit</div>
              <v-list-item-title class="headline mb-1 text-right">{{formatAngka(cashBalance.limit)}}
              </v-list-item-title>
              <div>
                <v-divider></v-divider>
              </div>
            </v-list-item-content>
          </v-list-item>
          <v-card-actions>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex lg4 sm6 xs12>
        <v-card class="ma-3" elevation="0" style="border: thin solid rgba(0,0,0,.12)">
          <v-list-item>
            <v-list-item-content>
              <div class="text-right mb-2">Cash</div>
              <v-list-item-title class="headline mb-1 text-right">
                {{formatAngka(cashBalance.amount)}}
              </v-list-item-title>
              <div>
                <v-divider></v-divider>
              </div>
              {{cashBalance.name}}
            </v-list-item-content>
            <v-list-item-action>
              <v-btn
                  class="ma-2"
                  :loading="loadingCashout"
                  :disabled="loadingCashout"
                  color="secondary"
                  @click="toggleDialogCashout"
              >
                Cashout
              </v-btn>
            </v-list-item-action>
          </v-list-item>
          <v-card-actions>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <v-tabs  v-model="tab">
      <v-tab>Bills</v-tab>
      <v-tab>Rekening</v-tab>

      <v-tab-item>
        <SerpulBills/>
      </v-tab-item>

      <v-tab-item>
        <Rekening/>
      </v-tab-item>
    </v-tabs>
    <ModalBills/>
    <ModalUpdateConfirmation/>
    <LoadingDialog/>
    <ResultDialog/>
    <ModalAddRekening/>
    <ModalCashout/>
  </v-layout>
</template>

<script>
import {mapActions, mapState} from "vuex";
import SerpulBills from "@/components/bayartempo/SerpulBills";
import Utils from "@/plugins/utils";
import ModalBills from "@/components/bayartempo/ModalBills";
import ModalUpdateConfirmation from "@/components/bayartempo/ModalUpdateConfirmation";
import LoadingDialog from "@/components/bayartempo/LoadingDialog";
import ResultDialog from "@/components/bayartempo/ResultDialog";
import Rekening from "@/components/bayartempo/Rekening";
import ModalAddRekening from "@/components/bayartempo/ModalAddRekening";
import ModalCashout from "@/components/bayartempo/ModalCashout";

export default {
  name: "ModalKerja",
  components: {Rekening, ResultDialog, LoadingDialog, ModalUpdateConfirmation, SerpulBills, ModalBills, ModalAddRekening, ModalCashout },
  mounted() {
    this.getBalance()
  },
  computed: {
    ...mapState('Bayartempo',['wallet', 'dialog', 'detailBills', 'activeId', 'modalCashout', 'loadingCashout', 'cashBalance'])
  },
  methods: {
    ...mapActions('Bayartempo',['getBills', 'toggleDialogCashout','getBalance']),
    formatAngka(val){
      return Utils.formatAngka(val)
    }
  }
}
</script>

<style scoped>

</style>